import React, { useState } from 'react';
import { mockData } from '../mockData';
import { Star } from 'lucide-react';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { testimonials } = mockData;

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 to-slate-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#204080] to-[#3a5bb8] drop-shadow-sm mb-4 tracking-tight leading-snug font-serif">
            What Our Patients Say
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Real stories from people who've experienced our exceptional care
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative">
            {/* Testimonial Cards */}
{/* Testimonial Cards */}
<div className="overflow-hidden">
  <div
    className="flex transition-transform duration-500 ease-in-out"
    style={{ transform: `translateX(-${currentIndex * 100}%)` }}
  >
    {testimonials.map((testimonial) => (
      <div key={testimonial.id} className="w-full flex-shrink-0 px-4">
        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-lg border border-blue-100 flex flex-col items-center text-center">

          {/* Author Name */}
<h4 className="text-lg md:text-xl font-bold mb-3" style={{ color: '#204080' }}>
  {testimonial.name}
</h4>
         

          {/* Quote */}
          <blockquote className="text-lg md:text-xl text-slate-800 leading-relaxed font-serif tracking-tight">
            “{testimonial.content}”
          </blockquote>
          <br/>
        {/* Stars */}
          <div className="flex justify-center mb-6 gap-1">
            {[...Array(5)].map((_, i) => (
              <Star
                key={i}
                size={28}
                className={
                  i < testimonial.rating
                    ? "text-yellow-400 fill-yellow-400 drop-shadow-md"
                    : "text-gray-300 fill-gray-200"
                }
                style={i < testimonial.rating ? { filter: 'drop-shadow(0 0 6px #fde68a)' } : {}}
              />
            ))}
          </div>
        </div>
        
      </div>
    ))}
  </div>
</div>



            {/* Navigation Buttons */}
            <button
              onClick={prevTestimonial}
              className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-4 bg-white rounded-full p-3 shadow-lg hover:shadow-xl transition-all duration-300 text-blue-600 hover:text-blue-800"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>

            <button
              onClick={nextTestimonial}
              className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-4 bg-white rounded-full p-3 shadow-lg hover:shadow-xl transition-all duration-300 text-blue-600 hover:text-blue-800"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>

          {/* Dots Indicator */}
          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === currentIndex 
                    ? 'bg-blue-600 scale-125' 
                    : 'bg-blue-200 hover:bg-blue-400'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;